import React, {useEffect, useState} from 'react';
import OrderTags from "./OrderTags";
import OrderButtons from "./OrderButtons";
import { useDispatch, useSelector } from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import { AddMealToCart, UseGetMealAdById } from "../../../api/useMeal";
import { setUserValue } from "../../../reducers/userReducer";
import { useTranslation } from "react-i18next";

interface OrderMainDetailsProps {
    selectedOrder: any;
    acceptTime: (time: any) => void;
    acceptOrder: (order: any) => void;
}

const OrderMainDetails = (props: OrderMainDetailsProps) => {
    const { t } = useTranslation();
    
    const user = useSelector((state: any) => state.user);
    const {category, details, order} = useParams();
    const [selectedProduct, setSelectedProduct] = useState<any>();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [acceptedTime, setAcceptedTime] = useState<any>(null);
    const [guestsNr, setGuestsNr] = useState<any>('1');
    const [reserveName, setReserveName] = useState<any>(user.name);

    const scrollToTop = () => {
        window.scrollTo({ top: 122, behavior: 'smooth' }); // 137
    }

    const acceptOrderHandler = async () => {
        //props.acceptOrder(selectedProduct);
        
        const meal = {
            mealId: selectedProduct?.data?._id || '',
            name: selectedProduct?.data?.name || '',
            price: parseFloat(selectedProduct?.data?.priceNow || 0),
            quantity: parseFloat(guestsNr),
            reserveName: reserveName,
            time: acceptedTime,
            type: selectedProduct.isDineIn ? 'dineIn' : 'takeOut'
        }
        
        try {
            if (user && user.id && meal) {
                setLoading(true);
               
                const result = await AddMealToCart(user.id, meal);
                
                console.log("AddMealToCart: ", result);
                
                if (result) {
                    dispatch(setUserValue({ key: "cartCount", value: result.cart.meals.length }));
                    navigate(`/cart`);
                    
                    setLoading(false);
                } else {
                    dispatch(setUserValue({ key: "cartCount", value: 0 }));
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
            
            /* AddMealToCart(user.id, meal).then((response: any) => {
                if (response && response.status === 200) {
                    console.log("AddMealToCart response: ", response);
                
                }
            }); */
        // console.log("selectedProduct: ", selectedProduct);
        // selectedProduct && localStorage.setItem("acceptedOrder", JSON.stringify(selectedProduct));
    }

    const acceptTimeHandler = (time: any) => {
        // acceptTime(time);
        setAcceptedTime(time);
    }

    useEffect(() => {
        scrollToTop();

        const fetchData = async () => {
            try {
                //if (props.selectedOrder) {
                //    setSelectedProduct(props.selectedOrder);
                //    console.log("props.selectedOrder: ", props.selectedOrder);
                //}

                //if (!props.selectedOrder && details) {
                if (details) {
                    console.log("details: ", details);
                    
                    UseGetMealAdById(details).then((response: any) => {
                        if (response && response.status === 200) {
                            const fetchedData = response.result;
                            console.log("response.result: ", response.result);
                            console.log("details: ", details);
                            setSelectedProduct(response.result);
                            //localStorage.setItem("selectedOrder", fetchedData);
                            /*const categoriesMap = new Map<string, any[]>();

														// fetchedData.length > 0 && setSelectedCategory(fetchedData[0]?.category);

														fetchedData && fetchedData.length > 0 && fetchedData.forEach((item: any) => {
															if (item && item.data.isActivated) {
																if (item.data.validUntilTime !== null) {
																	const validUntilTime = new Date();
																	const [hours, minutes] = item.data.validUntilTime.split(":");
																	validUntilTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0);

																	const currentTime = new Date();

																	if (currentTime > validUntilTime) {
																		// return;
																	}
																}

																item.category.forEach((category: string) => {
																	const normalizedCategory = category.toLowerCase();
																	if (!categoriesMap.has(normalizedCategory)) {
																		categoriesMap.set(normalizedCategory, []);
																	}
																	categoriesMap.get(normalizedCategory)!.push(item);
																});
															}
														});
														Array.from(categoriesMap.keys()).length > 0 && Array.from(categoriesMap.keys()).map((category, index) => {
															index === 0 && setSelectedCategory(category);
															// setSelectedCategory()
														});
														setCategoriesMap(categoriesMap);*/
                        }
                    });
                }

                //}
                
                
                /*const response = await getData(dispatch);
                if (response) {
                    response.forEach((item: any) => {
                        item.data.forEach((i: any) => {
                            if (i.name.toLowerCase().replace(/\s/g, "-") === details ? details : "") {
                                console.log("Selected product: ", i);
                                setSelectedProduct(i);
                                // localStorage.setItem("selectedCategory", JSON.stringify(item.category));
                            }
                        });
                    });
                }*/
            }
            catch (error) {
                console.log(error);
            }
        }
        fetchData().then();
    }, [dispatch, category, details]);

    return (
        <>
            {
                selectedProduct && selectedProduct.data && (
                    <div className="orderMainDetails__container-wrap">
                        <div className="orderMainDetails__container">
                            <div className="orderMainDetails__container-card">
                                <div className="orderMainDetails__container-card-wrap">
                                    <div className="orderMainDetails__container-card-image-wrap">
                                        <div className="orderMainDetails__container-card-image">
                                            <div className="orderMainDetails__container-data-reservation-wrap">
                                                <div className="orderMainDetails__container-data-reservation">
                                                    <span>{selectedProduct.isDineIn ? t('const.dineIn') : t('const.takeOut')}</span>
                                                </div>
                                            </div>
                                            <img
                                                src={selectedProduct.data.image}
                                                alt='card image'
                                            />
                                        </div>
                                    </div>
                                    <div className="orderMainDetails__container-card-name-wrap">
                                        <div className="orderMainDetails__container-card-name">
                                            <span>{
                                                selectedProduct.isDineIn ?
                                                  t(`const.${selectedProduct.data?.onOption.toLowerCase()}`)
                                                  :
                                                  selectedProduct.data?.name
                                            }</span>
                                        </div>
                                        {
                                            selectedProduct.isDineIn ? (
                                              <div className="orderMainDetails__container-card-price-wrap">
                                                  <div className="orderMainDetails__container-card-discount">
                                                      <span>{selectedProduct.data.discount}% {t('const.discount')}</span>
                                                  </div>
                                              </div>
                                            ) : (
                                              <div className="orderMainDetails__container-card-price-wrap">
                                                  <div className="orderMainDetails__container-card-price">
                                                      <span>€{selectedProduct.data.priceBefore}</span>
                                                  </div>
                                                  <div className="orderMainDetails__container-card-discount">
                                                      <span>€{selectedProduct.data.priceNow}</span>
                                                  </div>
                                              </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="orderMainDetails__container-description">
                                <div className="orderMainDetails__container-description-wrap">
                                    <div className="orderMainDetails__container-description-title-wrap">
                                        <div className="orderMainDetails__container-description-title">
                                            <span>{selectedProduct.isDineIn ? selectedProduct.data.name : category}</span>
                                        </div>
                                        <div className="orderMainDetails__container-description-place">
                                            <span>{selectedProduct.data?.restaurantId?.address?.name}</span>
                                        </div>
                                    </div>

                                    <div className="orderMainDetails__container-description-time-wrap">
                                        <div className="orderMainDetails__container-description-dine-in-wrap">
                                            <div className="orderMainDetails__container-description-dine-in-wrap-image">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/dine-in-icon.svg`}
                                                    alt='dine-in-icon'
                                                />
                                            </div>
                                            <div className="orderMainDetails__container-description-dine-in">
                                                <span>{selectedProduct.data?.availableCount || 1} {t('food.available')}</span>
                                            </div>
                                        </div>
                                        <div className="orderMainDetails__container-description-timer-wrap">
                                            <div className="orderMainDetails__container-description-timer-wrap-image">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/timer-icon.svg`}
                                                    alt='timer-icon'
                                                />
                                            </div>
                                            <div className="orderMainDetails__container-description-timer">
                                                {/* <span>{t('pages.food.validUntil')} {selectedProduct.isDineIn ? selectedProduct.data.validUntilTime : "∞"} </span> */}
                                                <span>{t('food.validUntil')} {selectedProduct.data.validUntilTime}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="orderMainDetails__container-description-main-wrap">
                                        <div className="orderMainDetails__container-description-main-title-wrap">
                                            <span>{t('food.description')}</span>
                                        </div>
                                        {
                                            selectedProduct.isDineIn && (
                                            <div className="orderMainDetails__container-description-content-discount-wrap">
                                                <span>{`${t('food.minimum')} €${selectedProduct.data.minSpend} ${t('food.spend')}`}</span>
                                            </div>
                                          )
                                        }
                                        <div className="orderMainDetails__container-description-content-wrap">
                                            <span>{selectedProduct.data.description}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="orderMainDetails__container-buttons-wrap">
                                    <OrderButtons
                                        acceptOrderHandle={acceptOrderHandler}
                                        selectedOrder={selectedProduct}
                                        acceptTimeHandle={acceptTimeHandler}
                                        isDineIn={selectedProduct.isDineIn}
                                        guests={guestsNr}
                                        setGuestsNr={setGuestsNr}
                                        reserveName={reserveName}
                                        setReserveName={setReserveName}
                                        weeklyPlan={selectedProduct?.data?.week || []}
                                        timeStep={selectedProduct?.data?.interval}
                                    />
                                </div>

                                <div className="orderMainDetails__container-tags-wrap not-adaptive">
                                    <OrderTags tags={selectedProduct.isDineIn ? selectedProduct?.data?.restaurantId?.tags || [] : selectedProduct.data.tags}/>
                                </div>
                            </div>
                        </div>
                        {/*<div className="orderMainDetails__container-tags-wrap adaptive">
                            <OrderTags tags={selectedProduct.data.tags}/>
                        </div>*/}
                    </div>
                )
            }
        </>
    );
};

export default OrderMainDetails;